@if (classDetail) {
<div class="class-info-main">
  @if (classDetail.bannerImage) {
    <section class="class-info__image"
      [style.background-image]="'url('+ imageUrl +')'">
    </section>
  }
  <section class="class-info__detail" [ngClass]="{'mt-20':classDetail.bannerImage === ''}">
    <div class="class-info__detail--header">
      <div class="class-info__detail--header-left">
        <h1 class="class-info__detail__name">{{classDetail.LessonName}}</h1>
        <div class="class-info__detail__location">
          <mat-icon class="location_on" aria-hidden="false" aria-label="location">location_on</mat-icon>
          &nbsp;{{classDetail.LocationName}}
        </div>
      </div>
      @if (classDetail.BaseRate) {
        <div class="class-info__detail--header-right">
          <label for="rate" class="class-info__detail__rate-label">{{'Startingfrom' | translate}}</label>
          <div class="class-info__detail__rate-value">{{operatingCurrency}} {{classDetail.BaseRate | currencyDecimalFormatter}}
          </div>
        </div>
      }
    </div>
    <div class="class-info__detail--content">
      <div class="class-info__detail__item">
        <label for="activity-type" class="class-info__detail__item--label">{{'activityType' | translate}}</label>
        <div class="class-info__detail__item--value">{{classDetail.activityType}}</div>
      </div>
      <div class="class-info__detail__item">
        <label for="start-date" class="class-info__detail__item--label">{{'startDate' | translate}}</label>
        <div class="class-info__detail__item--value">{{classDetail.StartDate | localizeDate : 'L'}}</div>
      </div>
      <div class="class-info__detail__item">
        <label for="endDate" class="class-info__detail__item--label">{{'endDate' | translate}}</label>
        <div class="class-info__detail__item--value">{{classDetail.EndDate | localizeDate : 'L'}}</div>
      </div>
      @if (showAvailableSlotCount) {
        <div class="class-info__detail__item">
          <label for="available" class="class-info__detail__item--label">{{'availableSlots' | translate}}</label>
          @if (classDetail.ClassType === ClassType.Session) {
            <i class="icon-Info class-info__detail__slotInfo"  matTooltipPosition="above"  matTooltip="{{ 'sessionSlotCountInfoMessage' | translate}}"></i>
          }
          <div class="class-info__detail__item--value class-info__detail__item__value-avilable">
            {{classDetail.AvailableSlots}}
          </div>
        </div>
      }
      <div class="class-info__detail__item class-info__detail__item_last">
        <label for="instructor" class="class-info__detail__item--label">{{'Instructor' | translate}}</label>
        <div class="class-info__detail__item--value class-info__ellipsis" title="{{classDetail.Staffs}}">
          {{classDetail.Staffs}}</div>
      </div>
    </div>
    @if (!showAvailableSlotCount || classDetail.AvailableSlots == 0) {
      <div class="class-info__detail__note">{{'checkAvailabilityOtherDays' | translate}}</div>
    }
    <div class="class-info__detail--footer">
      <app-button [buttontype]="backButton" (valueChange)="backClick($event)">
      </app-button>
      <app-button [buttontype]="bookButton" (valueChange)="bookClick($event)">
      </app-button>
    </div>
  </section>
  @if (classDetail.Description) {
    <section class="class-info__description">
      <h2 class="heading-secondary" >
        {{'sescription' | translate}}
      </h2>
      <p class="class-info__description-text" [ngClass]="classDetail.Description && classDetail.Description.length > 150 ? 'text-justify' : 'text-center' ">
        {{classDetail.Description | textCutter: (descriptionReadMoreClicked ? null : textMaxLegth)}} {{classDetail.Description.length}}
        @if (classDetail.Description.length > textMaxLegth) {
          <span class="class-info__read-more"
            (click)="descriptionReadMoreClicked = !descriptionReadMoreClicked">
            {{descriptionReadMoreClicked ? ('readLess' | translate) : ('readMore' | translate)}}
          </span>
        }
      </p>
    </section>
  }
  @if (classDetail.safetyInformation) {
    <section class="class-info__description">
      <h2 class="heading-secondary">
        {{'safetyInformation' | translate}}
      </h2>
      <p class="class-info__description-text">
        {{classDetail.safetyInformation | textCutter: (safetyInformationReadMoreClicked ? null : textMaxLegth)}}
        @if (classDetail.safetyInformation.length > textMaxLegth) {
          <span class="class-info__read-more"
            (click)="safetyInformationReadMoreClicked = !safetyInformationReadMoreClicked">
            {{safetyInformationReadMoreClicked ? ('readLess' | translate) : ('readMore' | translate)}}
          </span>
        }
      </p>
    </section>
  }
</div>
}